import type { FeatureFlagsResponse } from '@libs/types';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@api';
import { queryKeys } from '@constants';

async function getFeatures(signal?: AbortSignal): Promise<FeatureFlagsResponse> {
  const { data } = await apiClient.get<FeatureFlagsResponse>('api/features', { signal });
  return data;
}

/**
 * Every runtime feature flag, resolved for the current tenant. Its own
 * endpoint rather than a field on `UserInfo`: the profile is only refreshed
 * on login/token-refresh, so a flag a platform admin just flipped would not
 * reach an already-signed-in session until then.
 */
export const useFeatureFlags = () =>
  useQuery({
    queryKey: queryKeys.features.all,
    queryFn: ({ signal }) => getFeatures(signal),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
